import { useEffect, useState } from "react";
import styled from "styled-components";
import dayjs from "dayjs";
import { Page } from "../../../components/page-base";
import useUserStore from "../../../store/user";
import { Container } from "../../sellers/pages/styles";
import { NOVIDADES } from "../lista";
import { lerVistas, marcarTodasVistas } from "../vistas";

export const Novidades: React.FC = () => {
  const { user } = useUserStore();
  const usuario = user?.name;
  // o selo "Novo" vale para esta visita; ao abrir, tudo passa a contar como visto
  const [novasNestaVisita] = useState(() => {
    const vistas = lerVistas(usuario);
    return new Set(NOVIDADES.filter((n) => !vistas.has(n.id)).map((n) => n.id));
  });

  useEffect(() => {
    marcarTodasVistas(usuario);
  }, [usuario]);

  return (
    <Page.Root>
      <Container id="dashboard-container">
        <Page.HeaderAux />
        <Page.Header title="Novidades" subtitle="O que mudou na ferramenta e como usar" />
        <Lista>
          {NOVIDADES.map((n) => (
            <Cartao key={n.id} aria-labelledby={`novidade-${n.id}`}>
              <Topo>
                <time dateTime={n.data}>{dayjs(n.data).format("DD/MM/YYYY")}</time>
                {novasNestaVisita.has(n.id) && <Selo>Novo</Selo>}
              </Topo>
              <h2 id={`novidade-${n.id}`}>{n.titulo}</h2>
              <ul>
                {n.itens.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              {n.comoUsar && (
                <ComoUsar>
                  <strong>Como usar:</strong> {n.comoUsar}
                </ComoUsar>
              )}
            </Cartao>
          ))}
        </Lista>
      </Container>
    </Page.Root>
  );
};

const Lista = styled.div`
  width: calc(100% - 64px);
  max-width: 820px;
  margin: 24px 0 48px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 768px) {
    width: calc(100% - 32px);
  }
`;

const Cartao = styled.article`
  box-sizing: border-box;
  padding: 18px 22px;
  border-radius: 16px;
  border: 1px solid #e3e6ea;
  background: #ffffff;
  font-family: var(--font-sans);
  color: var(--text, #3c4043);

  h2 {
    margin: 6px 0 10px;
    font-size: 17px;
    line-height: 1.35;
    color: #202124;
  }

  ul {
    margin: 0;
    padding-left: 20px;
    font-size: 14px;
    line-height: 1.6;
  }

  @media (max-width: 480px) {
    padding: 14px 16px;
  }
`;

const Topo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #5f6368;
`;

const Selo = styled.span`
  padding: 2px 8px;
  border-radius: 10px;
  background: #e8f0fe;
  color: #1967d2;
  font-weight: 600;
  font-size: 11px;
`;

const ComoUsar = styled.p`
  margin: 12px 0 0;
  padding: 10px 12px;
  border-radius: 10px;
  background: #f1f3f4;
  font-size: 13px;
  line-height: 1.5;
`;
